import { PropsWithChildren, useMemo } from 'react'
import { useMargin } from '../utils/hooks'

type Props = {
  type?: 'button' | 'submit' | 'reset'
  btnType?: 'outline' | 'filled'
  btnColor?: 'customer' | 'accent' | 'light' | 'dark'
  className?: string
  marginBottom?: string
  marginTop?: string
  disabled?: boolean
  onClick?: () => void
}

export const CustomerButton = (props: PropsWithChildren<Props>) => {
  const { type = 'button', className } = props
  const {
    btnType = 'filled',
    marginBottom,
    marginTop,
    btnColor = 'customer',
    ...buttonProps
  } = props

  const classes = useMemo(() => {
    let common =
      'py-2 px-6  text-[0.9rem] rounded-[36px] customer-button-font font-medium transition-colors duration-100'

    let colorClasses = ''

    if (btnType === 'outline') {
      colorClasses += 'border !bg-transparent '
    }

    switch (btnColor) {
      case 'customer':
        colorClasses += ' bg-customerPrimary-400 hover:bg-customerPrimary-300'
        if (btnType === 'outline') {
          colorClasses += ' border-customerPrimary-400 text-customerPrimary-400'
        } else colorClasses += ' text-customerInverse'
        break
      case 'accent':
        colorClasses += ' bg-customerAccent-400 hover:bg-customerAccent-300'
        if (btnType === 'outline') {
          colorClasses += ' border-customerAccent-400 text-customerAccent-400'
        } else colorClasses += ' text-customerAccentInverse'
        break
      case 'light':
        colorClasses += ' bg-neutral-100 hover:bg-neutral-200'
        if (btnType === 'outline') {
          colorClasses +=
            ' border-neutral-100 text-neutral-100 hover:!bg-neutral-100 hover:text-neutral-800'
        } else {
          colorClasses += ' text-neutral-800'
        }
        break
      case 'dark':
        colorClasses += ' bg-neutral-800 hover:bg-neutral-900'
        if (btnType === 'outline') {
          colorClasses +=
            ' border-neutral-800 text-neutral-800 hover:!bg-neutral-800 hover:text-neutral-100'
        } else {
          colorClasses += ' text-neutral-100'
        }
        break
    }

    return `${common} ${colorClasses}`
  }, [btnColor, btnType])

  const margins = useMargin({ data: { marginBottom, marginTop } })

  return (
    <button
      {...buttonProps}
      type={type}
      className={`${className} ${classes} ${margins}`}
    >
      {props.children}
    </button>
  )
}
